import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function NaverCallback() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state') || 'default_state';

    if (!code) {
      alert('인가 코드가 없습니다.');
      navigate('/');
      return;
    }

    // ✅ 내 서버에 POST 요청 (절대 네이버에 직접 요청 X)
    fetch('http://localhost:4000/naver/token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, state }),
    })
      .then(res => res.json())
      .then(data => {
        const accessToken = data.access_token;
        if (!accessToken) throw new Error('access_token 없음');

        // ✅ 내 서버에 GET 요청 → 사용자 정보 받아오기
        return fetch('http://localhost:4000/naver/user', {
          headers: { Authorization: accessToken },
        });
      })
      .then(res => res.json())
      .then(userData => {
        const { email, nickname, profile_image } = userData.response;

        // ✅ 회원가입 페이지로 이동하며 사용자 정보 전달
        navigate('/register', {
          state: {
            email,
            nickname,
            profile_image,
            provider: 'naver',
          },
        });
      })
      .catch(err => {
        console.error('❌ 네이버 로그인 실패:', err.message || err);
        alert('로그인 실패. 다시 시도해주세요.');
        navigate('/');
      });
  }, [location, navigate]);

  return <div>🔄 네이버 로그인 처리 중입니다...</div>;
}

export default NaverCallback;
